import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {Stocktaking} from "../../../model/stocktaking";
import {DatePipe} from "@angular/common";
import {Observable} from "rxjs/Observable";

@Component({
  selector: 'vb-stocktaking',
  templateUrl: './stocktaking.component.html',
  styleUrls: ['./stocktaking.component.css']
})
export class StocktakingComponent extends AbstractVisbosComponent implements OnInit {

  @Input()
  stocktaking: Stocktaking;

  @Output()
  savingEntries: EventEmitter<Observable<any>> = new EventEmitter();



  data = (st: Stocktaking) => st ? [
    {
      label: 'Bezeichner',
      value: st.label
    },
    {
      label: 'Inventarisiertes Lager',
      value: st.depot ? st.depot.label : null
    },
    {
      label: 'Verantwortlicher',
      value: st.responsible_user.label
    },
    {
      label: 'Inventurhelfer',
      value: st.involved_persons_names
    },
    {
      label: 'Inventurbeginn',
      value: this.datePipe.transform(st.created_at, 'shortDate')
    },
    {
      label: 'Zuletzt gepspeichert',
      value: this.datePipe.transform(st.updated_at, 'shortDate')
    },
    {
      label: 'Inventurstichtag',
      value: this.datePipe.transform(st.reporting_date, 'shortDate')
    },
    {
      label: 'Notizen',
      value: st.notes,
      size: 'col-xs-12'
    }

  ].filter(e => e.value) : [];

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private datePipe: DatePipe) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stocktaking/components/stocktaking/stocktaking.component.ts